<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!contact">
      <span class="loader"></span>
    </span>
    <div v-if="contact" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="contact"
        v-model="activeTab"
      >
        <tab-pane title="contact" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <contact-view-global v-if="alreadyLoadedTabs.includes('1')"
            v-show="activeTab === '1'" :contact="contact" @onContractUpdated="get" />
        </tab-pane>
        <tab-pane title="contact" id="2">
          <span slot="title">
            <i class="fab fa-accusoft"></i>
            {{ $t("CONTACTS.PROPERTIES") }}
          </span>
          <contact-property-list-table v-if="alreadyLoadedTabs.includes('2')"
            v-show="activeTab === '2'" :filterOwner="contact?.id" />
        </tab-pane>

        <tab-pane title="contact" id="3">
          <span slot="title">
            <i class="fab fa-accusoft"></i>
            {{ $t("COMMON.COMMUNICATIONS") }}
          </span>
          <contact-communication-list-table 
          v-if="alreadyLoadedTabs.includes('3')"
            v-show="activeTab === '3'"
          :filterContact="contact?.id"
          :contact="contact"
          @onCommunicationCreated="communicationCreated"
          :key="componentKey" />
        </tab-pane>

        <tab-pane
          title="files"
          id="4"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component v-if="alreadyLoadedTabs.includes('4')"
            v-show="activeTab === '4'" :object="contact" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="5"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <contact-view-logs v-if="alreadyLoadedTabs.includes('5')"
            v-show="activeTab === '5'" :contact="contact" />
        </tab-pane>
        <tab-pane title="comments" id="6">
          <span slot="title">
            <i class="fas fa-comments"></i>
            {{ $t("COMMON.SHIPPMENT") }}
          </span>
          <elixio-connect-shipment-manager
          v-if="alreadyLoadedTabs.includes('6')"
            v-show="activeTab === '6'"
            shippable-type="Contact"
            :shippable-id="contact.id"
          />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import ContactViewLogs from "../partials/ContactViewLogs.vue";
import ContactViewGlobal from "../partials/ContactViewGlobal.vue";
import ContactPropertyListTable from "../partials/ContactPropertyListTable.vue";
import ContactCommunicationListTable from "../partials/ContactCommunicationListTable.vue";
import ElixioConnectShipmentManager from "@/components/ElixioConnect/ShipmentManager.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ContactViewLogs,
    ListFileComponent,
    ContactPropertyListTable,
    ContactCommunicationListTable,
    ContactViewGlobal,
    ElixioConnectShipmentManager
  },

  mixins: [],

  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      contact: null,
      componentKey: 0,
      activeTab: '1',
      alreadyLoadedTabs: ['1']
    };
  },

  computed: {},

  watch: {
    activeTab(newTab) {
      if (!this.alreadyLoadedTabs.includes(newTab)) {
        this.alreadyLoadedTabs.push(newTab);
      }
    }
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("contacts/get", this.contactId);
        this.contact = this.$store.getters["contacts/contact"];
        console.log(this.contact);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    communicationCreated() {
      this.componentKey += 1;
    },
  },
};
</script>
